import { Icon } from "@components/blocks/icon/Icon";
import { findInternalIDByExternalID } from "@lib/utils/findInternalIDByExternalID";
import { MARKER_OBJECT } from "@repo/map-helpers";
import { ROUNDED_ICONS_IDS } from "@repo/map-helpers/src/markers";
import { FacilityDetailsResponse } from "@repo/shared-types";
import { Marker } from "react-map-gl";

import { IMarkerPopup } from "../markerPopup/MarkerPopup";

export function POI({
  poi,
  onMarkerClick,
}: {
  poi: FacilityDetailsResponse;
  onMarkerClick: (marker: Omit<IMarkerPopup, "onClose">) => void;
}) {
  return (
    <Marker
      longitude={poi.coordinates.longitude}
      latitude={poi.coordinates.latitude}
      style={{
        cursor: "pointer",
      }}
      onClick={() => {
        onMarkerClick({
          id: poi.id,
          latitude: poi.coordinates.latitude,
          longitude: poi.coordinates.longitude,
          categoryId: findInternalIDByExternalID(poi.categoryId),
          facility: poi,
        });
      }}
    >
      <div
        className={`overflow-hidden shadow-3xl ${
          ROUNDED_ICONS_IDS.indexOf(
            findInternalIDByExternalID(poi.categoryId)
          ) > -1
            ? "rounded-full"
            : "rounded-[10px]"
        }`}
      >
        <Icon
          iconName={
            MARKER_OBJECT[findInternalIDByExternalID(poi.categoryId)] ??
            "markerFallback"
          }
        />
      </div>
    </Marker>
  );
}
